
/* injects from baggage-loader */

'use strict';

import ProjectDonationWizardStep2Component from './project-donation-wizard.step2.component';

const ProjectDonationWizardStep2PageModule = angular.module('project-donation-wizard-step-2-module', [
  'ui.router'
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('project-donation-wizard.step2', {
        url: '/2',
        component: 'projectDonationWizardStep2',
        // Resolve promises into controller bindings, see component for bindings
        resolve: {
          stripeAccount: function (Parse, User) {
            if (User.isUserLoggedIn()) {
              return Parse.Cloud.run('fetchStripeCustomer');
            } else {
              return false;
            }
          }
        }
      });
  })
  .component('projectDonationWizardStep2', new ProjectDonationWizardStep2Component());

export default ProjectDonationWizardStep2PageModule;



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/step2/project-donation-wizard.step2.module.js